var site = site || {};

(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignMenuFormatterV1 = {
    attach: function (context) {
      var formatter = $('.eh-thewink-hp-redesign-menu-formatter-v1', context),
        $header = $('#header'),
        $stickyBarContent = $('#sticky_bar_content'),
        $stickyBar = $('#sticky-bar'),
        $tertiaryNav = $stickyBar.find('.tertiary-nav'),
        $stickyBarSiteLogo = $stickyBar.find('.site-logo'),
        $theWinkHeroHeader = formatter.closest('.eh-thewink-hp-redesign-formatter').find('.eh-thewink-hp-redesign-hero-header'),
        $theWinkSplitText = formatter.closest('.eh-thewink-hp-redesign-formatter').find('.split-width-image-text-tout'),
        $theWinkSIHeroHeader = formatter.closest('.eh-thewink-special-issues-formatter').find('.eh-thewink-special-issues-hero-header');

      // Add body class to be used to enable stickybar on page load
      $('body').addClass('stickyEnabledOnPageLoad');

      if (formatter.hasClass('display-menu-below-logo') && $theWinkHeroHeader.length) {
        $theWinkHeroHeader.addClass('hero-header-redesign');
        formatter.closest('.basic-nodeblock-noderef').addClass('basic-nodeblock-noderef-menu');
      } else if (formatter.hasClass('display-menu-below-logo') && $theWinkSplitText.length) {
        $theWinkSplitText.closest('.basic-nodeblock-noderef').addClass('hero-header-redesign');
        formatter.closest('.basic-nodeblock-noderef').addClass('basic-nodeblock-noderef-menu');
      }
      // Add "thewink-special-issues" body class if we're using the "Special Issues" top hero template
      if ($theWinkSIHeroHeader.length) {
        $('body').addClass('thewink-special-issues');
      }

      // Not sure if the brand wants to show the gnav offer in the wink
      formatter.closest('.container').find('.nav-promo').css({ 'display': 'none' });

      formatter.once('eh-thewink-hp-redesign-menu-formatter').each(function () {
        var thisFormatter = $(this);
        // For the "Special Issues" section
        var $specialIssues = thisFormatter.find('.special-issues'),
          specialIssuesHex = thisFormatter.find('.special-issues-hex').attr('data-special-issues-hex');

        if ($specialIssues.length > 0 && specialIssuesHex.length > 0) {
          // "Special Issues" menu item hex color
          thisFormatter.find('.special-issues').css('color', specialIssuesHex);
        }
        // Add "special-issues-link" class to document body
        if ($specialIssues.length) {
          $('body').addClass('special-issues-link');
        }

        // Set TheWink sticky bar and the mobile menu header
        // Some Android tablets returs 1 (true) to "site.client.isMobile" while having the "device-pc" body class
        if (!site.client.isMobile && !$('body').hasClass('device-mobile') ||
           ($('body').hasClass('device-pc') && $(window).width() <= 1280 && $('body').hasClass('device-pc') && !$('body').hasClass('device-mobile') && $(window).height() <= 800) ||
           ($('body').hasClass('device-pc') && $(window).width() <= 800 && $('body').hasClass('device-pc') && !$('body').hasClass('device-mobile') && $(window).height() <= 1280)) {
          var theWinkLogo = thisFormatter.find('.thewink-menu-logo').attr('data-thewink-menu-logo'),
            $cloneTheWinkNav = thisFormatter.clone(),
            sticky_content = $cloneTheWinkNav,
            lastScrollTop = 0;

          // Append and hide "The Wink" logo image
          $('<img class="the-wink-logo hidden" src="' + theWinkLogo + '" alt="">').insertAfter($stickyBarSiteLogo.find('img'));
          // Show the "The Wink" menu on the old "The Wink" pages
          if ($('body').hasClass('section-thewink') && !$('body').hasClass('thewink-special-issues')) {
            thisFormatter.closest('.region-page-top').find('.node').css({ 'border-bottom': '1px solid #dadada' });
            // Append the "The Wink" logo
            thisFormatter.prepend('<div class="thewink-logo"><a title="The Wink Home" href="/thewink"><img alt="" src="' + theWinkLogo + '" class="thewink-menu-logo-img"></a></div>');
          }
          // Show #top for the Clinique stickybar subnav elements
          $('body.device-pc.stickyEnabledOnPageLoad').find('#top').show();
          // Put "The Wink" 2.0 menu (non-sticky) on a fixed position for the "Special Issues" section only
          if ($('body').hasClass('thewink-special-issues') && !$stickyBar.hasClass('thewink-sticky-bar')) {
            thisFormatter.addClass('thewink-special-issues-menu');
            $('.thewink-special-issues-menu').css({
              'max-width': 'none',
              'display': 'block'
            });
            $('.thewink-special-issues-menu').show();
            thisFormatter.css({ 'visibility': 'visible' });
          }
          // Make the "The Wink" 2.0 menu stick to the bottom of the page on page load or window resize
          $(window).on('scroll', _.throttle(function () {
            var st = $(this).scrollTop();

            if (st > lastScrollTop) {
              // downscroll
              // Hide "The Wink" 2.0 menu on the "Special Issues" section
              // if ($theWinkSIHeroHeader.length && st > 0 && $('body').hasClass('thewink-special-issues')) {
              // $('.thewink-special-issues-menu').fadeOut('slow');
              // }
              if ($theWinkHeroHeader.length && st >= $theWinkHeroHeader.height()) {
                // SlideUp and hide for a few the "Clinique" stickybar menu
                if ($stickyBar.not('.thewink-sticky-bar') && $stickyBar.css('top') === '0px' && !$('#sticky_bar_content_new').length && !$('body').hasClass('section-thewink')) {
                  // Hide #top
                  $('body.device-pc.stickyEnabledOnPageLoad').find('#top').hide();
                  $stickyBar.animate({
                    top: '-48px'
                  }, 600, function () {
                    $stickyBarSiteLogo.find('img.logo').hide();
                    $stickyBar.find('.item-more').removeClass('open');
                    $stickyBar.addClass('thewink-sticky-bar');
                  });
                  thisFormatter.css({
                    'visibility': 'visible',
                    'display': 'block'
                  });
                  thisFormatter.find('.eh-thewink-hp-redesign-menu').css({ 'display': 'block' });
                }
                if ($stickyBar.hasClass('thewink-sticky-bar')) {
                  $tertiaryNav.css({ 'display': 'none' });
                  if (!$('#sticky_bar_content_new').length) {
                    $('<div id="sticky_bar_content_new" class="container"></div>').insertAfter($stickyBarContent);
                  }
                  $('#sticky_bar_content_new').html(sticky_content);
                  $stickyBarContent.hide();
                  // thisFormatter.css({'visibility':'hidden'});
                  if ($('body').hasClass('thewink-special-issues')) {
                    thisFormatter.css({
                      'visibility': 'visible',
                      'display': 'block'
                    });
                  } else {
                    // thisFormatter.css({'visibility':'hidden'});
                    thisFormatter.css({
                      'visibility': 'visible',
                      'display': 'block'
                    });
                    thisFormatter.find('.eh-thewink-hp-redesign-menu').css({ 'display': 'block' });
                  }
                  // Show the "The Wink" stickybar menu on scroll down pass the hero
                  if ($stickyBar.css('top') === '-48px' && $('#sticky_bar_content_new').length && !$('body').hasClass('section-thewink')) {
                    $stickyBarSiteLogo.find('img.the-wink-logo').show();
                    // Link the "The Wink" HP stickybar menu logo to "/thewink". Replace Clinique HP "/" with the "/thewink" URL
                    $stickyBarSiteLogo.find('a').attr('href', thisFormatter.find('.thewink-logo a').attr('href'));
                    $stickyBar.animate({
                      top: '0'
                    }, 500);
                    // Hide "The Wink" 2.0 menu on the "Special Issues" section
                    // $('.thewink-special-issues-menu').fadeOut('slow');
                  }
                }
              } else {
                thisFormatter.css({
                  'visibility': 'visible',
                  'display': 'block'
                });
                thisFormatter.find('.eh-thewink-hp-redesign-menu').css({ 'display': 'block' });
              }
              // Old "The Wink" article, index and see all* pages and the Special Issues page
              if (st >= $header.height() && $('body').hasClass('section-thewink') && $('body').hasClass('node-type-page') ||
                  st >= $header.height() && $('body').hasClass('section-thewink') && $('body').hasClass('page-index-term-list') ||
                  st >= 24 && $('body').hasClass('section-thewink') && $('body').hasClass('section-see-all') ||
                  st >= $theWinkSIHeroHeader.height() && $theWinkSIHeroHeader.length) {
                // Add "thewink-sticky-bar" to the "The Wink" article, index and see all* pages
                if (!$stickyBar.hasClass('thewink-sticky-bar') && $stickyBar.css('top') === '0px' && !$('#sticky_bar_content_new').length) {
                  // Hide #top
                  $('body.device-pc.stickyEnabledOnPageLoad').find('#top').hide();
                  $stickyBar.animate({
                    top: '-48px'
                  }, 600, function () {
                    $stickyBarSiteLogo.find('img.logo').hide();
                    $stickyBar.addClass('thewink-sticky-bar');
                    $stickyBar.find('.item-more').removeClass('open');
                    if ($stickyBar.hasClass('thewink-sticky-bar')) {
                      if (!$('#sticky_bar_content_new').length) {
                        $('<div id="sticky_bar_content_new" class="container"></div>').insertAfter($stickyBarContent);
                      }
                      $('#sticky_bar_content_new').html(sticky_content);
                      $stickyBarContent.hide();
                      $tertiaryNav.css({ 'display': 'none' });
                      $stickyBarSiteLogo.find('img.the-wink-logo').css({ 'display': 'block' });
                      // Link the "The Wink" HP stickybar menu logo to "/thewink". Replace Clinique HP "/" with the "/thewink" URL
                      $('#sticky-bar.thewink-sticky-bar').find('.site-logo a').attr('href', thisFormatter.find('.thewink-logo a').attr('href'));
                    }
                  });
                }
                if ($stickyBar.css('top') === '-48px' && $('#sticky_bar_content_new').length) {
                  // thisFormatter.css({'visibility':'hidden'});
                  if ($('body').hasClass('thewink-special-issues')) {
                    thisFormatter.css({
                      'visibility': 'visible',
                      'display': 'block'
                    });
                  } else {
                    thisFormatter.css({ 'visibility': 'hidden' });
                  }
                  $stickyBarSiteLogo.find('img.the-wink-logo').show();
                  $stickyBar.animate({
                    top: '0'
                  }, 500);
                  // Hide the "The Wink" menu when scroll down on existing (old) "The Wink" article pages
                  thisFormatter.css({ 'margin-top': '0' });
                  thisFormatter.closest('.node').css({ 'border-bottom': 'none' });
                }
              } else {
                thisFormatter.css({ 'visibility': 'visible' });
              }
            } else {
              // upscroll
              if (st <= $theWinkHeroHeader.height() || st <= $theWinkSIHeroHeader.height()) {
                if ($stickyBar.hasClass('thewink-sticky-bar') && $stickyBar.css('top') === '0px' && $('#sticky_bar_content_new').length && !$('body').hasClass('section-thewink')) {
                  // Hide the "The Wink" 2.0 stickybar menu
                  $stickyBarSiteLogo.find('img.the-wink-logo').slideUp(800);
                  $('#sticky_bar_content_new').slideUp(800);
                  // Hide #top
                  $('body.device-pc.stickyEnabledOnPageLoad').find('#top').hide();
                  $stickyBar.animate({
                    top: '-48px'
                  }, 500, function () {
                    // Hide the "The Wink" 2.0 stickybar elements
                    $('#sticky_bar_content_new').remove();
                    $stickyBarSiteLogo.find('img.the-wink-logo').hide();
                    $stickyBar.find('.item-more').removeClass('open');
                    $(this).removeClass('thewink-sticky-bar');
                    // Load the "Clinique" stickybar elements
                    $stickyBarSiteLogo.find('img.logo').show();
                    $stickyBarContent.show();
                    $tertiaryNav.show();
                    $stickyBar.animate({
                      top: '0px'
                    }, 500);
                  });
                }
                // Remove "thewink-sticky-bar" to hide the "The Wink" 2.0 stickybar elements on the old "The Wink" article pages
                if ($('body').hasClass('section-thewink')) {
                  $stickyBar.removeClass('thewink-sticky-bar');
                }
                if ($stickyBar.not('.thewink-sticky-bar')) {
                  // Show the "Clinique" stickybar menu when scroll back up
                  if ($stickyBar.css('top') === '-48px' && !$('#sticky_bar_content_new').length && !$('body').hasClass('section-thewink')) {
                    $stickyBarSiteLogo.find('img.logo').show();
                    $stickyBarContent.show();
                    $tertiaryNav.show();

                    $stickyBar.removeClass('thewink-sticky-bar');
                    $stickyBar.animate({
                      top: '0'
                    }, 400);
                  }
                  // Show the "The Wink" 2.0 menu (not sticky) when scroll back up
                  thisFormatter.css({ 'visibility': 'visible' });
                  // Show "The Wink" 2.0 menu on the "Special Issues" only
                  // $('.thewink-special-issues-menu').fadeIn('slow');
                  // Show the "Clinique" stickybar elements on the old "The Wink" article pages
                  if ($('body').hasClass('section-thewink')) {
                    $tertiaryNav.css({ 'display': 'block' });
                    $stickyBarSiteLogo.find('img.the-wink-logo').hide();
                    $stickyBarSiteLogo.find('img.logo').show();
                    if ($('#sticky_bar_content_new').length) {
                      $('#sticky_bar_content_new').remove();
                    }
                    $stickyBarContent.show();
                    // Put the "The Wink" 2.0 menu (not sticky) underneath the "Clinique" stickybar
                    thisFormatter.css({ 'margin-top': '48px' });
                    thisFormatter.closest('.node').css({ 'border-bottom': '1px solid #dadada' });
                    // Show #top for the Clinique stickybar subnav elements
                    $('body.device-pc.stickyEnabledOnPageLoad').find('#top').show();
                    // Link the "Clinique" stickybar menu logo to the HP "/". Replace "The Wink" HP "/thewink" with the "Clinique" HP URL "/"
                    $stickyBarSiteLogo.find('a').attr('href', '/');
                  }
                } // if ($stickyBar.not('.thewink-sticky-bar'))
              } // if (st <= $theWinkHeroHeader.height())
            } // if (st > lastScrollTop) else
            lastScrollTop = st;
          }, 100)); // $(window).on(scroll)

          // Adjust thewink nav and remove last menu item
          thisFormatter.addClass('thewink-nav');
          var $thisWinkNav = $('.thewink-nav');
          var $menuItemsLi = $thisWinkNav.find('.eh-thewink-hp-redesign-menu-v1.tWMenuItem');
          var lastItem = $menuItemsLi.last();

          lastItem.remove();
        } // if

        // Mobile
        if (site.client.isMobile) {
          // Relocate page-top region only for the old The Wink mobile article pages
          if ($('body').hasClass('section-thewink')) { // "section-thewink" is the original "The Wink" body class
            $('.region.region-page-top').insertAfter($('#top'));
            // Offers promo MUST be hidden on the old "The Wink" articles/pages for the mobile nav to work
            $('.nav-promo, .offer-promo').hide();
          }
          var thewinkMobileMenuLink = thisFormatter.find('.thewink-mobile-link');

          // Toggle open/close mobile menu
          // TODO: slideDown() animation is a bit bumpy, so it needs optimization
          thewinkMobileMenuLink.once('thewink-mobile-link').toggle(function () {
            if ($(this).find('i').hasClass('icon-angle-down')) {
              $(this).find('i').removeClass('icon-angle-down').addClass('icon-angle-up');
              thisFormatter.find('.eh-thewink-hp-redesign-menu').slideDown('slow', function () {
                thisFormatter.addClass('open-menu');
              });
            }
          }, function () {
            if ($(this).find('i').hasClass('icon-angle-up')) {
              $(this).find('i').removeClass('icon-angle-up').addClass('icon-angle-down');
              thisFormatter.find('.eh-thewink-hp-redesign-menu').slideUp('fast', function () {
                thisFormatter.removeClass('open-menu');
              });
            }
          });

          // Close/hide mobile menu on close outside
          $('html').once('close-menu').on('click', function () {
            thewinkMobileMenuLink.find('i').removeClass('icon-angle-up').addClass('icon-angle-down');
            if (!thisFormatter.hasClass('display-menu-below-logo')) {
              thisFormatter.find('.eh-thewink-hp-redesign-menu').slideUp('fast', function () {
                thisFormatter.removeClass('open-menu');
              });
            }
          });

          // Adjust The Wink mobile menu header on window scroll to keep it fixed on top
          var updateMenuPos = function () {
            // Close mobile header menu on scroll
            thisFormatter.find('.thewink-mobile-link').find('i').removeClass('icon-angle-up').addClass('icon-angle-down');
            thisFormatter.find('.eh-thewink-hp-redesign-menu').slideUp('fast', function () {
              thisFormatter.removeClass('open-menu');
            });
            // Place mobile header menu on top on scroll
            if ($(this).scrollTop() >= $header.height()) {
              thisFormatter.addClass('fixed-pos').removeClass('static-pos');
            } else {
              thisFormatter.addClass('static-pos').removeClass('fixed-pos');
            }
          };

          $(window).scroll(throttle(updateMenuPos, 100));
        } // if
      });

      // Show language toggle in sticky nav
      enableLanguageToogle();
      this.copyTheWinkMenu(formatter);
    },
    copyTheWinkMenu: function (formatter, context) {
      var $regionPageTop = formatter.closest('.region-page-top');
      var $nodeWink = $regionPageTop.find('.node');
      var $nodeBlock = $nodeWink.closest('.block-template-eh-thewink-hp-menu-v1');
      var $menuFormatter = $nodeBlock.find('.eh-thewink-hp-redesign-menu-formatter');
      var $ehArticleFormatter = $('.eh-article-formatter', context);
      var $copyNodeBlock = $nodeBlock.clone(true);
      var bps = Unison.fetch.all();
      var bp = Unison.fetch.now();
      var isMobile = parseInt(bp.width, 10) < parseInt(bps['usn-medium-max'], 10);

      if ($('body').hasClass('page-node') && $nodeBlock.length && $menuFormatter.hasClass('display-menu-below-logo')) {
        $ehArticleFormatter.prepend($copyNodeBlock);
        $copyNodeBlock.find('.node').css({ 'border-bottom': '' });
        $ehArticleFormatter.children().eq(1).addClass('display-menu-redesign');
        $nodeBlock.remove();
      } else if (!$ehArticleFormatter.length && !isMobile && $menuFormatter.length) {
        $menuFormatter.removeClass('display-menu-below-logo');
      }
    }
  };

  // Custom throttle
  // On mobile, _.throttle and .throttle are failing
  function throttle(func, delay) {
    var timer = 0;

    return function () {
      var context = this,
        args = [].slice.call(arguments);

      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }

  // Enable language toggle in Wink Page
  function enableLanguageToogle() {
    $(window).on('load', function() {
      var $languageToggleStickyContainer = $('.nav-language-switcher-sticky');

      if ($languageToggleStickyContainer.length) {
        $languageToggleStickyContainer.show();
      }
    });
  }
})(jQuery);
